// -----------------------------------------------------------------------------
// Scripts for speaker modal
// -----------------------------------------------------------------------------

$('.speaker-item').on('click', function(){
  const modalBody = $('#speakerModal').find('[data-modal-body]');
  const personId = $(this).attr('data-speaker-item');
  const modalContent = $(`#${personId}`).html();

  modalBody.html(modalContent);
});